// extracted by mini-css-extract-plugin
export default {"root":"MwGIg","chevron":"HHWMD","content":"Akvp8","size-sm":"HhjKj","sizeSm":"HhjKj","size-md":"x4ugh","sizeMd":"x4ugh","controlDefaultColor":"OgW55"};